const es = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title':
    'Nombre del origen de detección',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title': 'Id. de usuario',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title': 'URL de ServiceNow',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': 'Contraseña',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': 'URL no válida',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': 'Frecuencia de detección',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    'Solicite a los usuarios responder preguntas de autenticación basadas en conocimientos (KBA).',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    'Consulte sus aplicaciones y cargas de trabajo a través de uno de estos orígenes de detección populares. Disfrutará ciertos beneficios, como detalles precargados, recomendaciones priorizadas y una vista completa del estado de incorporación.',
  'INTEGRATIONS.DISCOVERY.BACK': 'Atrás',
  'INTEGRATIONS.DISCOVERY.TITLE': 'Configuración de detección',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': 'Próximamente…',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': 'Más información',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    'Ingrese las credenciales de la aplicación para establecer una conexión. Al establecer la conexión correctamente, podrá importar datos.',
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING':
    'Se produjo un error al cargar la página.',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    'Intente actualizar la página o vuelva a verificarlo más tarde. Si el error persiste, comuníquese con su administrador.',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': 'Volver a cargar',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title':
    'Configuración de la conexión',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'Clases CI***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title':
    'Asignación de atributos',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title':
    'Detalles de conexión',
  'INTEGRATIONS.BUTTON.SAVE': 'Guardar',
  'INTEGRATIONS.DISCOVERY.SELECT': 'Seleccionar',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION': 'Crear nueva conexión',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': 'Usar esta conexión',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'Se guardó ServiceNow',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    'La conexión al origen de detección ServiceNow se probó y guardó correctamente. Importe datos para finalizar la configuración de detección. Se puede omitir…',
  'INTEGRATIONS.DISCOVERY.IMPORT': 'Importar activos',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': 'Omitir por ahora',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE':
    'Una vez iniciada la importación no se puede cancelar',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': 'Guía',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING': 'Seleccionar conexión existente',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': 'Nombre de conexión',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    'Detectamos la configuración de {total, plural, one {una} other {#}} conexión existente:',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': 'Iniciar importación',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA':
    'Importar datos desde un archivo Excel. Espere…',
  'INTEGRATIONS.TRY.AGAIN': 'Vuelva a intentar',
  'INTEGRATIONS.CLOSE': 'Cerrar',
  'INTEGRATIONS.ERROR.CONNECTION': 'Error de conexión. Inténtelo de nuevo.',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    'Puede abandonar la página mientras espera. Le notificaremos una vez que se complete el proceso.',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': 'Importar origen de detección',
  'INTEGRATIONS.FILEUPLOAD.HEADING':
    'Importe su origen de detección desde un archivo',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE': 'Descargar archivo de muestra',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': 'Nombre del origen de detección',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': 'Ingresar nombre del archivo',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    'Ingrese un nombre válido. Solo se permiten letras, números y algunos símbolos.',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': 'Cargando…',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': 'Continuar',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    'Estos son los primeros 10 registros del archivo XLSX cargado.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER':
    'Falta el encabezado obligatorio',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX':
    'Se detectaron errores en las columnas',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    'Corrija los problemas antes de continuar con la importación de datos.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': 'Excluir de la importación',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE':
    'Configuración de la incorporación de la aplicación',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    'Identificamos el tipo de aplicación. Confirme si este es el tipo de aplicación correcto que está incorporando.',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    'El tipo de aplicación que está incorporando es {applicationName}',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    'No, seleccionar de una lista de aplicaciones',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM': 'Sí, es correcto',
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': 'Integraciones',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': 'Agregar integración',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH':
    'No se encontró ningún resultado para',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': 'No',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX':
    'integraciones encontradas.',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN':
    'No hay integraciones ocultas disponibles.',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': 'Aplicaciones detectadas',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': 'Propietario:',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': 'Última fecha de detección',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': 'Error en la conexión',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': 'Los usuarios tienen acceso',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': 'Origen de detección',
  'INTEGRATIONS.BUTTON.ENABLE': 'Habilitar',
  'INTEGRATIONS.BUTTON.DISABLE': 'Deshabilitar',
  'INTEGRATIONS.ENABLING': 'Habilitando',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': 'Detección',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': 'Volver a cargar',
  'INTEGRATIONS.DASHBOARD.ONBOARD': 'Incorporar',
  'INTEGRATIONS.DASHBOARD.HIDE': 'Ocultar',
  'INTEGRATIONS.DASHBOARD.UNHIDE': 'Mostrar',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL':
    'Pestañas de configuración de detección',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    '¿Desea descartar los cambios no guardados?',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    'Tiene cambios sin guardar Si continúa, se perderán los cambios.',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': 'Descartar cambios',
  'INTEGRATIONS.BUTTON.CANCEL': 'Cancelar',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': 'Error de guardado',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL':
    'Volver a la página anterior',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': 'Ícono de la aplicación',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': 'Ejecutar manualmente',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE':
    'Error de deshabilitación',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE': 'Error de habilitación',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION':
    'La deshabilitación se realizó correctamente.',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION':
    'La habilitación se realizó correctamente.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    'Actualmente se está realizando otra importación.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    'Actualmente los activos se están importando con otro proceso. Inténtelo de nuevo más tarde.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED': 'Error de importación',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS':
    'Importación de activos desde ServiceNow',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    'Puede abandonar la página mientras espera. Le notificaremos una vez que se complete el proceso.',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    'Agregar nueva fila de asignación de atributos',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': 'Agregar atributo',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(Vacío)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': 'Eliminar asignación',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'Campo de ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'Campo de Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW':
    'Buscar atributo de ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT':
    'Buscar atributo de Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(Personalizado)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': 'Error al guardar',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': 'Configuración de programación',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': 'en {timeLabel} UTC.',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': 'Repetir el',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': 'Repetir en x días',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': 'Repetir cada',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL':
    'Ingresar intervalo',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    'Intervalo de repetición (número de días, semanas o meses)',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': 'Día',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': 'Semana(s)',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': 'Mes',
  'INTEGRATIONS.DAYS.SUN': 'Dom',
  'INTEGRATIONS.DAYS.MON': 'Lun',
  'INTEGRATIONS.DAYS.TUE': 'Mar',
  'INTEGRATIONS.DAYS.WED': 'Mié',
  'INTEGRATIONS.DAYS.THU': 'Jue',
  'INTEGRATIONS.DAYS.FRI': 'Vie',
  'INTEGRATIONS.DAYS.SAT': 'Sáb',
  'INTEGRATIONS.BUTTON.DISABLING': 'Deshabilitando',
  'INTEGRATIONS.BUTTON.SAVED': 'Guardado',
  'INTEGRATIONS.BUTTON.SAVING': 'Guardando',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE':
    '¿Está seguro de que desea deshabilitarlo? ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    'Al deshabilitar el origen de detección, la importación de activos se detendrá y no podrá configurar el origen.',
  'INTEGRATIONS.DISCOVERY.HERE': 'aquí',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    'El origen de detección se creó correctamente, pero se produjo un error en la conexión con ServiceNow. Para comenzar a importar activos, actualice los detalles de la conexión en la página de configuración del origen de detección. ',
};

export default es;
